/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function () {

  /** Permission Check */

  $('body').on('click', '[name="contact-submit"]', function () {
    if ($('#agree_contact').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("Bitte akzeptie unsere Datenschutzhinweise, bevor Du Deine Nachricht absendest.");
      return false;
    }
  });


  /** Move Payment Icons */

  $('ul.Footer__PaymentList.HorizontalList').detach().appendTo('.footer-bottom .footer-bottom-payment')


  /** Tooltip Box */

  var tooltipIsClicked01 = false;

  $('section[data-custom-class="featured-product"] .dot.dot01').hover(
    function () {
      tooltipIsClicked02 = false;
      tooltipIsClicked03 = false;
      tooltipIsClicked04 = false;
      tooltipIsClicked05 = false;
      tooltipIsClicked06 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");

      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').addClass("active");
    }, function () {
      if (!tooltipIsClicked01) {
        $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      }
    }
  );

  $('section[data-custom-class="featured-product"] .dot.dot01').click(function () {
    if (tooltipIsClicked01) {
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      tooltipIsClicked01 = false;
    } else {
      tooltipIsClicked02 = false;
      tooltipIsClicked03 = false;
      tooltipIsClicked04 = false;
      tooltipIsClicked05 = false;
      tooltipIsClicked06 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').addClass("active");
      tooltipIsClicked01 = true;
    }
  });

  var tooltipIsClicked02 = false;

  $('section[data-custom-class="featured-product"] .dot.dot02').hover(
    function () {
      tooltipIsClicked01 = false;
      tooltipIsClicked03 = false;
      tooltipIsClicked04 = false;
      tooltipIsClicked05 = false;
      tooltipIsClicked06 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').addClass("active");
    }, function () {
      if (!tooltipIsClicked02) {
        $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      }
    }
  );

  $('section[data-custom-class="featured-product"] .dot.dot02').click(function () {
    if (tooltipIsClicked02) {
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      tooltipIsClicked02 = false;
    } else {
      tooltipIsClicked01 = false;
      tooltipIsClicked03 = false;
      tooltipIsClicked04 = false;
      tooltipIsClicked05 = false;
      tooltipIsClicked06 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').addClass("active");
      tooltipIsClicked02 = true;
    }
  });

  var tooltipIsClicked03 = false;

  $('section[data-custom-class="featured-product"] .dot.dot03').hover(
    function () {
      tooltipIsClicked01 = false;
      tooltipIsClicked02 = false;
      tooltipIsClicked04 = false;
      tooltipIsClicked05 = false;
      tooltipIsClicked06 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').addClass("active");
    }, function () {
      if (!tooltipIsClicked03) {
        $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      }
    }
  );

  $('section[data-custom-class="featured-product"] .dot.dot03').click(function () {
    if (tooltipIsClicked03) {
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      tooltipIsClicked03 = false;
    } else {
      tooltipIsClicked01 = false;
      tooltipIsClicked02 = false;
      tooltipIsClicked04 = false;
      tooltipIsClicked05 = false;
      tooltipIsClicked06 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').addClass("active");
      tooltipIsClicked03 = true;
    }
  });

  var tooltipIsClicked04 = false;

  $('section[data-custom-class="featured-product"] .dot.dot04').hover(
    function () {
      tooltipIsClicked01 = false;
      tooltipIsClicked02 = false;
      tooltipIsClicked03 = false;
      tooltipIsClicked05 = false;
      tooltipIsClicked06 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').addClass("active");
    }, function () {
      if (!tooltipIsClicked04) {
        $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      }
    }
  );

  $('section[data-custom-class="featured-product"] .dot.dot04').click(function () {
    if (tooltipIsClicked04) {
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      tooltipIsClicked04 = false;
    } else {
      tooltipIsClicked01 = false;
      tooltipIsClicked02 = false;
      tooltipIsClicked03 = false;
      tooltipIsClicked05 = false;
      tooltipIsClicked06 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').addClass("active");
      tooltipIsClicked04 = true;
    }
  });

  var tooltipIsClicked05 = false;

  $('section[data-custom-class="featured-product"] .dot.dot05').hover(
    function () {
      tooltipIsClicked01 = false;
      tooltipIsClicked02 = false;
      tooltipIsClicked03 = false;
      tooltipIsClicked04 = false;
      tooltipIsClicked06 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').addClass("active");
    }, function () {
      if (!tooltipIsClicked05) {
        $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      }
    }
  );

  $('section[data-custom-class="featured-product"] .dot.dot05').click(function () {
    if (tooltipIsClicked05) {
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      tooltipIsClicked05 = false;
    } else {
      tooltipIsClicked01 = false;
      tooltipIsClicked02 = false;
      tooltipIsClicked03 = false;
      tooltipIsClicked04 = false;
      tooltipIsClicked06 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').addClass("active");
      tooltipIsClicked05 = true;
    }
  });

  var tooltipIsClicked06 = false;

  $('section[data-custom-class="featured-product"] .dot.dot06').hover(
    function () {
      tooltipIsClicked01 = false;
      tooltipIsClicked02 = false;
      tooltipIsClicked03 = false;
      tooltipIsClicked04 = false;
      tooltipIsClicked05 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').addClass("active");
    }, function () {
      if (!tooltipIsClicked06) {
        $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");
      }
    }
  );

  $('section[data-custom-class="featured-product"] .dot.dot06').click(function () {
    if (tooltipIsClicked06) {
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').removeClass("active");
      tooltipIsClicked06 = false;
    } else {
      tooltipIsClicked01 = false;
      tooltipIsClicked02 = false;
      tooltipIsClicked03 = false;
      tooltipIsClicked04 = false;
      tooltipIsClicked05 = false;
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip01').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip02').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip03').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip04').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip05').removeClass("active");
      $('section[data-custom-class="featured-product"] .tooltip-box.tooltip06').addClass("active");
      tooltipIsClicked06 = true;
    }
  });

  
  /** Move Blog Additional-Products */

  $('.template-article section[data-custom-class="additional-blog-products"]').detach().appendTo('.template-article .Article__Body')


  /** Page Landing */

  $('.CollectionInner.landing .ProductList .Grid__Cell').removeClass("1/3--tablet-and-up").addClass("1/2--tablet-and-up");

  
  /** Page Landing load-more */

  $('.landing-grills section[data-custom-class="favoriten"] .SectionFooter .Button').text("Mehr anzeigen");

  var grillLandingIsClicked = false;

  $('.landing-grills section[data-custom-class="favoriten"] .ProductListWrapper .Grid__Cell:nth-child(5)').addClass("invisible");
  $('.landing-grills section[data-custom-class="favoriten"] .ProductListWrapper .Grid__Cell:nth-child(6)').addClass("invisible");
  $('.landing-grills section[data-custom-class="favoriten"] .ProductListWrapper .Grid__Cell:nth-child(7)').addClass("invisible");
  $('.landing-grills section[data-custom-class="favoriten"] .ProductListWrapper .Grid__Cell:nth-child(8)').addClass("invisible");

  $('.landing-grills section[data-custom-class="favoriten"] .SectionFooter .Button').click(function (e) {
    if (!grillLandingIsClicked) {
      e.preventDefault();
      grillLandingIsClicked = true;
      $('.landing-grills section[data-custom-class="favoriten"] .SectionFooter .Button').text("Alle Produkte");

      $('.landing-grills section[data-custom-class="favoriten"] .ProductListWrapper .Grid__Cell:nth-child(5)').removeClass("invisible");
      $('.landing-grills section[data-custom-class="favoriten"] .ProductListWrapper .Grid__Cell:nth-child(6)').removeClass("invisible");
      $('.landing-grills section[data-custom-class="favoriten"] .ProductListWrapper .Grid__Cell:nth-child(7)').removeClass("invisible");
      $('.landing-grills section[data-custom-class="favoriten"] .ProductListWrapper .Grid__Cell:nth-child(8)').removeClass("invisible");
    }
  });

  /** Collection Landing load-more */



  if (!(window.location.href.indexOf("?page=") > -1)) {
    
    if($('.CollectionInner.landing .CollectionInner__Products .ProductList').children().length > 4) {
      $('.CollectionInner.landing .Pagination').hide();
      var collectionLandingIsClicked = false;
      $('.CollectionInner.landing .Grid__Cell').addClass("invisible");

      $('section[data-custom-class="landing-load-more-btn"] .Button').click(function (e) {
        if (!collectionLandingIsClicked) {
          e.preventDefault();
          collectionLandingIsClicked = true;
          $('.CollectionInner.landing .Grid__Cell').removeClass("invisible");
          $('section[data-custom-class="landing-load-more-btn"] .Button').text("Weniger zeigen");
          $('.CollectionInner.landing .Pagination').show();
        } else {
          e.preventDefault();
          collectionLandingIsClicked = false;
          $('.CollectionInner.landing .Grid__Cell').addClass("invisible");
          $('section[data-custom-class="landing-load-more-btn"] .Button').text("Mehr zeigen");
          $('.CollectionInner.landing .Pagination').hide();
          $('html, body').animate({
            scrollTop: $(".CollectionMain").offset().top - 360
          }, 500);
        }
      });
    } else {
      $('section[data-custom-class="landing-load-more-btn"]').hide();
    }

  } else {
    $('section[data-custom-class="landing-load-more-btn"]').hide();
  }


  /** Load Storelocator */

  if (window.location.href.indexOf("tools/service") > -1) {

    $('#main').addClass("storelocator");

    $('<div id="top-banner"></div>').insertBefore("#main");
    $("#top-banner").load('/pages/services section[data-custom-class="service-top-banner"]', function () {
      $.getScript("https://cdn.shopify.com/s/files/1/0523/8849/5543/files/service.js");
    });

    $('<div id="top-trenner"></div>').insertAfter("#top-banner");
    $("#top-trenner").load('/pages/services section[data-custom-class="scratched-top"]');

    $('<div id="garantieverlaengerung"></div>').insertAfter("#top-trenner");
    $("#garantieverlaengerung").load('/pages/services section[data-custom-class="service-garantieverlaengerung"]');

    $('<div id="locator-header"></div>').insertAfter("#garantieverlaengerung");
    $("#locator-header").load('/pages/services section[data-custom-class="locator-header"]');

    $('<div id="service-usp"></div>').insertAfter("#main");
    $("#service-usp").load('/pages/services section[data-custom-class="service-usp"]');

    $('<div id="scratched-top"></div>').insertAfter("#service-usp");
    $("#scratched-top").load('/pages/services section[data-custom-class="scratched-top-black"]');

    $('<div id="social-follow"></div>').insertAfter("#scratched-top");
    $("#social-follow").load('/pages/services section[data-custom-class="social-follow"]');
  }

  /** FAQ Functions */

  var firstblock = $('.bbq-wissen .Faq .Faq__Section:first-child');
  $(firstblock).show();
  $(firstblock).nextUntil('.bbq-wissen .Faq__Section').show();

  $('.bbq-wissen .FaqSummary .FaqSummary__Item').click(function (e) {
    $('.Faq .Faq__Section').hide();
    $('.Faq .Faq__Item').hide();

    var blockid = $(this).children(":first").attr("href")
    $(blockid).parent().show();
    $(blockid).parent().nextUntil('.bbq-wissen .Faq__Section').show();
  });

  /** Grillfinder */

  if (window.location.href.indexOf("grillfinder") > -1) {

    var step = 1;
    var tags = [];
    var lock = false;
    var pageNumber = "";

    const question01 = document.querySelector("#grillfinder .step.step01 .animate__animated");
    const question02 = document.querySelector("#grillfinder .step.step02 .animate__animated");
    const question03 = document.querySelector("#grillfinder .step.step03 .animate__animated");
    const question04 = document.querySelector("#grillfinder .step.step04 .animate__animated");
    const question05 = document.querySelector("#grillfinder .step.step05 .animate__animated");

    question01.addEventListener('animationend', () => {
      $("#grillfinder .step.step01 .animate__animated").removeClass('animate__pulse');
    });
    question02.addEventListener('animationend', () => {
      $("#grillfinder .step.step02 .animate__animated").removeClass('animate__pulse');
    });
    question03.addEventListener('animationend', () => {
      $("#grillfinder .step.step03 .animate__animated").removeClass('animate__pulse');
    });
    question04.addEventListener('animationend', () => {
      $("#grillfinder .step.step04 .animate__animated").removeClass('animate__pulse');
    });
    question05.addEventListener('animationend', () => {
      $("#grillfinder .step.step05 .animate__animated").removeClass('animate__pulse');
    });

    const step01 = document.querySelector("#grillfinder .animation-wrapper .grid-wrapper.step01");
    const step02 = document.querySelector("#grillfinder .animation-wrapper .grid-wrapper.step02");
    const step03 = document.querySelector("#grillfinder .animation-wrapper .grid-wrapper.step03");
    const step04 = document.querySelector("#grillfinder .animation-wrapper .grid-wrapper.step04");
    const step05 = document.querySelector("#grillfinder .animation-wrapper .grid-wrapper.step05");

    step01.addEventListener('animationend', () => {
      lock = false;
      $("#grillfinder .animation-wrapper .grid-wrapper.step01").removeClass('animate__slideOutLeft').removeClass('animate__slideInRight').removeClass('animate__slideOutRight').removeClass('animate__slideInLeft');
      if (step == 2) {
        $("#grillfinder .animation-wrapper .grid-wrapper.step01").hide();
      }
    });

    step02.addEventListener('animationend', () => {
      lock = false;
      $("#grillfinder .animation-wrapper .grid-wrapper.step02").removeClass('animate__slideOutLeft').removeClass('animate__slideInRight').removeClass('animate__slideOutRight').removeClass('animate__slideInLeft');
      if (step == 1) {
        $("#grillfinder .animation-wrapper .grid-wrapper.step02").hide();
      } else if (step == 3) {
        $("#grillfinder .animation-wrapper .grid-wrapper.step02").hide();
      }
    });

    step03.addEventListener('animationend', () => {
      lock = false;
      $("#grillfinder .animation-wrapper .grid-wrapper.step03").removeClass('animate__slideOutLeft').removeClass('animate__slideInRight').removeClass('animate__slideOutRight').removeClass('animate__slideInLeft');
      if (step == 2) {
        $("#grillfinder .animation-wrapper .grid-wrapper.step03").hide();
      } else if (step == 4) {
        $("#grillfinder .animation-wrapper .grid-wrapper.step03").hide();
      }
    });

    step04.addEventListener('animationend', () => {
      lock = false;
      $("#grillfinder .animation-wrapper .grid-wrapper.step04").removeClass('animate__slideOutLeft').removeClass('animate__slideInRight').removeClass('animate__slideOutRight').removeClass('animate__slideInLeft');

      if (step == 3) {
        $("#grillfinder .animation-wrapper .grid-wrapper.step04").hide();
      }
      else if (step == 5) {
        $("#grillfinder .animation-wrapper .grid-wrapper.step04").hide();
      }
    });

    step05.addEventListener('animationend', () => {
      lock = false;
      $("#grillfinder .animation-wrapper .grid-wrapper.step05").removeClass('animate__slideOutLeft').removeClass('animate__slideInRight').removeClass('animate__slideOutRight').removeClass('animate__slideInLeft');
      if (step == 4) {
        $("#grillfinder .animation-wrapper .grid-wrapper.step05").hide();
      }
    });

    const footerNote = document.querySelector("#grillfinder .footer-note p");

    footerNote.addEventListener('animationend', () => {
      if ((step == 4) || (step == 2)) {
        $("#grillfinder .footer-note p").hide();
      }
      $("#grillfinder .footer-note p").removeClass(' animate__fadeIn').removeClass('animate__fadeOut');
    });

    function scrollToFinder() {
      if (window.innerWidth <= 380) {
        $('html, body').animate({
          scrollTop: $("#grillfinder").offset().top - 110
        }, 500);
      }
      else if (window.innerWidth < 1140) {
        $('html, body').animate({
          scrollTop: $("#grillfinder").offset().top - 120
        }, 500);
      }
      else {
        $('html, body').animate({
          scrollTop: $("#grillfinder").offset().top - 180
        }, 500);
      }
    };

    function repeatStep01() {
      step = 1;
      $("#grillfinder .animation-wrapper .grid-wrapper.step02").css('display', 'grid').addClass('animate__slideOutRight');
      $("#grillfinder .animation-wrapper .grid-wrapper.step01").show().css('display', 'grid').addClass('animate__slideInLeft');

      $("#grillfinder .step.step02").hide();
      $("#grillfinder .step.step01").show();
      $("#grillfinder .step.step01 .animate__animated").addClass('animate__pulse');

      $(".grillfinder-navigation button").addClass('hidden');
    };

    function repeatStep02() {
      step = 2;
      $("#grillfinder .animation-wrapper .grid-wrapper.step03").css('display', 'grid').addClass('animate__slideOutRight');
      $("#grillfinder .animation-wrapper .grid-wrapper.step02").show().css('display', 'grid').addClass('animate__slideInLeft');

      $("#grillfinder .step.step03").hide();
      $("#grillfinder .step.step02").show();
      $("#grillfinder .step.step02 .animate__animated").addClass('animate__pulse');

      $("#grillfinder .footer-note p").addClass('animate__fadeOut');
    };

    function repeatStep03() {
      step = 3;
      $("#grillfinder .animation-wrapper .grid-wrapper.step04").css('display', 'grid').addClass('animate__slideOutRight');
      $("#grillfinder .animation-wrapper .grid-wrapper.step03").show().css('display', 'grid').addClass('animate__slideInLeft');

      $("#grillfinder .step.step04").hide();
      $("#grillfinder .step.step03").show();
      $("#grillfinder .step.step03 .animate__animated").addClass('animate__pulse');

      $("#grillfinder .footer-note p").show().addClass(' animate__fadeIn');
    };

    function repeatStep04() {
      step = 4;
      $("#grillfinder .animation-wrapper .grid-wrapper.step05").css('display', 'grid').addClass('animate__slideOutRight');
      $("#grillfinder .animation-wrapper .grid-wrapper.step04").show().css('display', 'grid').addClass('animate__slideInLeft');

      $("#grillfinder .step.step05").hide();
      $("#grillfinder .step.step04").show();
      $("#grillfinder .step.step04 .animate__animated").addClass('animate__pulse');
    };

    function showStep02() {
      step = 2;
      $("#grillfinder .animation-wrapper .grid-wrapper.step01").css('display', 'grid').addClass('animate__slideOutLeft');
      $("#grillfinder .animation-wrapper .grid-wrapper.step02").css('display', 'grid').addClass('animate__slideInRight');

      $("#grillfinder .step.step01").hide();
      $("#grillfinder .step.step02").show();
      $("#grillfinder .step.step02 .animate__animated").addClass('animate__pulse');

      $(".grillfinder-navigation button").removeClass('hidden');
    };

    function showStep03() {
      step = 3;
      $("#grillfinder .animation-wrapper .grid-wrapper.step02").css('display', 'grid').addClass('animate__slideOutLeft');
      $("#grillfinder .animation-wrapper .grid-wrapper.step03").css('display', 'grid').addClass('animate__slideInRight');

      $("#grillfinder .step.step02").hide();
      $("#grillfinder .step.step03").show();
      $("#grillfinder .step.step03 .animate__animated").addClass('animate__pulse');

      $("#grillfinder .footer-note p").show().addClass(' animate__fadeIn');
    };

    function showStep04() {
      step = 4;
      $("#grillfinder .animation-wrapper .grid-wrapper.step03").css('display', 'grid').addClass('animate__slideOutLeft');
      $("#grillfinder .animation-wrapper .grid-wrapper.step04").css('display', 'grid').addClass('animate__slideInRight');

      $("#grillfinder .step.step03").hide();
      $("#grillfinder .step.step04").show();
      $("#grillfinder .step.step04 .animate__animated").addClass('animate__pulse');

      $("#grillfinder .footer-note p").addClass('animate__fadeOut');
    };

    function showStep05() {
      step = 5;
      $("#grillfinder .animation-wrapper .grid-wrapper.step04").css('display', 'grid').addClass('animate__slideOutLeft');
      $("#grillfinder .animation-wrapper .grid-wrapper.step05").css('display', 'grid').addClass('animate__slideInRight');

      $("#grillfinder .step.step04").hide();
      $("#grillfinder .step.step05").show();
      $("#grillfinder .step.step05 .animate__animated").addClass('animate__pulse');
    };

    var firstResult = true;

    function showResults() {

      var urlParam = tags.join("+") + pageNumber;
      var collectionURL = "../collections/shop/" + urlParam;

      pageNumber = "";

      console.log(collectionURL);

      $("#grillfinder-result").load(collectionURL + " #collection-main", function () {

        $("#grillfinder-result .ProductList .Grid__Cell").removeClass("1/3--desk");
        $("#grillfinder-result .ProductList .Grid__Cell").addClass("1/4--desk");
        $("#grillfinder-result .ProductListWrapper .ProductItem").css('visibility', 'visible');

        $('section[data-custom-class="grillfinder-top-banner"] .grillfinder-banner.rellax').addClass("result");

        $('section[data-custom-class="grillfinder"]').hide();

        $("#grillfinder-result .Pagination__Nav .Pagination__NavItem.Link").each(function () {
          var attrHref = $(this).attr('href');
          if (typeof attrHref !== 'undefined' && attrHref !== false) {
            var linkURL = $(this).attr('href');
            var post = "?" + linkURL.split(/[?]+/).pop();
            $(this).attr("data-result-page", post);
            $(this).removeAttr("href");
          }
          $(this).css("cursor", "pointer");
        });

        if ($('.template-page section[data-custom-class="grillfinder-result"] #grillfinder-result .ProductListWrapper .Grid__Cell')[0]) {
          $('section[data-custom-class="grillfinder-top-banner"] .flex-wrapper .flex-section h1').text("Gut gemacht!");
          $('section[data-custom-class="grillfinder-top-banner"] .flex-wrapper .flex-section p').text("Hier sind unsere Empfehlungen für Dich.");
          $('section[data-custom-class="grillfinder-top-banner"] .flex-wrapper .flex-section h1').addClass("animate__pulse");
          $('section[data-custom-class="grillfinder-result"]').show();
        } else {
          $('section[data-custom-class="grillfinder-result-empty"]').show();
        }

        $('section[data-custom-class="grillfinder-link"]').show();

        if (firstResult) {
          $('html, body').animate({
            scrollTop: 0
          }, 500);
          firstResult = false
        } else {
          $('html, body').animate({
            scrollTop: $('section[data-custom-class="grillfinder-result"]').offset().top - 200
          }, 500);
        }



      })
    };

    /** Steps 1-4 */

    $('#grillfinder #balkon').click(function () {
      if (!lock) {
        lock = true;
        tags.push("balkon");
        showStep02();
        scrollToFinder();
      }
    });
    $('#grillfinder #terasse').click(function () {
      if (!lock) {
        lock = true;
        tags.push("terrasse");
        showStep02();
        scrollToFinder();
      }
    });
    $('#grillfinder #park-camping').click(function () {
      if (!lock) {
        lock = true;
        tags.push("park-camping");
        showStep02();
        scrollToFinder();
      }
    });
    $('#grillfinder #outdoor-kitchen').click(function () {
      if (!lock) {
        lock = true;
        tags.push("outdoor-kitchen");
        showStep02();
        scrollToFinder();
      }
    });

    /** Steps 5-8 */

    $('#grillfinder #bis-3-personen').click(function () {
      if (!lock) {
        lock = true;
        tags.push("1-3");
        showStep03();
        scrollToFinder();
      }
    });
    $('#grillfinder #4-5-personen').click(function () {
      if (!lock) {
        lock = true;
        tags.push("4-5");
        showStep03();
        scrollToFinder();
      }
    });
    $('#grillfinder #6-7-personen').click(function () {
      if (!lock) {
        lock = true;
        tags.push("6-7");
        showStep03();
        scrollToFinder();
      }
    });
    $('#grillfinder #8personen').click(function () {
      if (!lock) {
        lock = true;
        tags.push("8mehr");
        showStep03();
        scrollToFinder();
      }
    });

    /** Steps 9-12 */

    $('#grillfinder #holzkohle').click(function () {
      if (!lock) {
        lock = true;
        tags.push("holzkohle");
        showStep04();
        scrollToFinder();
      }
    });
    $('#grillfinder #gas').click(function () {
      if (!lock) {
        lock = true;
        tags.push("gas");
        showStep04();
        scrollToFinder();
      }
    });
    $('#grillfinder #elektro').click(function () {
      if (!lock) {
        lock = true;
        tags.push("elektro");
        showStep04();
        scrollToFinder();
      }
    });
    $('#grillfinder #smoker').click(function () {
      if (!lock) {
        lock = true;
        tags.push("smoker");
        showStep04();
        scrollToFinder();
      }
    });

    /** Steps 13-16 */

    $('#grillfinder #sommer').click(function () {
      if (!lock) {
        lock = true;
        tags.push("im-sommer");
        showStep05();
        scrollToFinder();
      }
    });
    $('#grillfinder #wochenende').click(function () {
      if (!lock) {
        lock = true;
        tags.push("am-wochenende");
        showStep05();
        scrollToFinder();
      }
    });
    $('#grillfinder #gelegentlich').click(function () {
      if (!lock) {
        lock = true;
        tags.push("gelegentlich");
        showStep05();
        scrollToFinder();
      }
    });
    $('#grillfinder #ganzjaehrig').click(function () {
      if (!lock) {
        lock = true;
        tags.push("ganzjährig");
        showStep05();
        scrollToFinder();
      }
    });

    /** Steps 17-20 */

    $('#grillfinder #klassiker').click(function () {
      if (!lock) {
        tags.push("klassiker");
        showResults();
        scrollToFinder();
      }
    });

    $('#grillfinder #ganze-gerichte').click(function () {
      if (!lock) {
        tags.push("ganze-gerichte");
        showResults();
        scrollToFinder();
      }
    });

    $('#grillfinder #grillflaeche').click(function () {
      if (!lock) {
        tags.push("mal-gucken");
        showResults();
        scrollToFinder();
      }
    });

    $('#grillfinder #ambitioniert').click(function () {
      if (!lock) {
        tags.push("ambitioniertes");
        showResults();
        scrollToFinder();
      }
    });

    /** Grillfinder Navigation */

    $('#grillfinder .grillfinder-navigation .grillfinder-nav button').click(function () {
      if (!lock && step != 1) {
        lock = true;
        tags.pop();
        if (step == 2) {
          repeatStep01();
        } else if (step == 3) {
          repeatStep02();
        } else if (step == 4) {
          repeatStep03();
        } else if (step == 5) {
          repeatStep04();
        }
      }
    });

    /** Grillfinder-Result Pagination */

    $(document).on("click", "#grillfinder-result .Pagination .Pagination__Nav .Pagination__NavItem.Link", function () {
      var pageNr = $(this).attr('data-result-page');
      pageNumber = pageNr;
      showResults();
    });
  }
});
